import React, { Component } from 'react';
import AuthService from './AuthService';
import AuthModalContext from '../contexts/AuthModalContext';
import constants from '../config';

export default function withAuth(AuthComponent) {
  const Auth = new AuthService(constants.DOMAIN);
  return class AuthWrapped extends Component {
    static contextType = AuthModalContext;

    constructor(props) {
      super(props);
      // Resolve user synchronously in constructor so the first render
      // never returns null (avoids brief flash of empty content)
      var user = null;
      if (Auth.loggedIn()) {
        try {
          user = Auth.getProfile();
        } catch (err) {
          Auth.logout();
        }
      }
      this.state = { user: user };
      this._shouldRedirect = !user;
    }

    componentDidMount() {
      // Redirect after mount if not logged in (can't use history in constructor)
      if (this._shouldRedirect) {
        this.props.history.replace('/');
        if (this.context) {
          this.context.openAuthModal('login');
        }
      }

      // Listen for logout while on a protected page
      this._handleAuthChange = () => {
        if (!Auth.loggedIn()) {
          this.props.history.replace('/');
        }
      };
      window.addEventListener('authStateChanged', this._handleAuthChange);
    }

    componentWillUnmount() {
      window.removeEventListener('authStateChanged', this._handleAuthChange);
    }

    render() {
      if (this.state.user) {
        return (
          <AuthComponent history={this.props.history} location={this.props.location} match={this.props.match} user={this.state.user} />
        );
      }
      return null;
    }
  };
}
